import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-proposition',
  templateUrl: './add-proposition.component.html'
})
export class AddPropositionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
